import { Controller } from "@hotwired/stimulus"

// Sprint 7 (01/06/2026) — Édition rapide referrals legacy (drawer "À nettoyer").
// Permet à Clémentine de corriger les champs raw + marquer import_issues=false.
export default class extends Controller {
  static targets = ["field", "status"]
  static values = { url: String }

  collectFields() {
    const attrs = {}
    this.fieldTargets.forEach(f => {
      attrs[f.dataset.field] = f.value
    })
    return attrs
  }

  save() {
    this.patch(this.collectFields(), "Enregistré ✓")
  }

  markCleaned() {
    const attrs = this.collectFields()
    attrs.import_issues = false
    this.patch(attrs, "Nettoyé ✓ — rechargement…", { reload: true })
  }

  patch(attrs, successMsg, opts = {}) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    this.flashStatus("Sauvegarde…", "warning")

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({ referral: attrs })
    }).then(r => r.json()).then(data => {
      if (data.ok) {
        this.flashStatus(successMsg, "success")
        if (opts.reload) setTimeout(() => window.location.reload(), 600)
      } else {
        this.flashStatus(`Erreur : ${(data.errors || []).join(", ")}`, "error")
      }
    }).catch(err => {
      console.error("[referral-clean] save failed", err)
      this.flashStatus("Erreur réseau", "error")
    })
  }

  flashStatus(msg, level) {
    if (!this.hasStatusTarget) return
    const colors = { success: "var(--color-success)", warning: "var(--color-warning)", error: "var(--color-danger)" }
    this.statusTarget.textContent = msg
    this.statusTarget.style.color = colors[level] || "var(--color-text-secondary)"
  }
}
